import { render, staticRenderFns } from "./payableDialog.vue?vue&type=template&id=50473e28&scoped=true&"
import script from "./payableDialog.vue?vue&type=script&lang=js&"
export * from "./payableDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50473e28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50473e28')) {
      api.createRecord('50473e28', component.options)
    } else {
      api.reload('50473e28', component.options)
    }
    module.hot.accept("./payableDialog.vue?vue&type=template&id=50473e28&scoped=true&", function () {
      api.rerender('50473e28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/SharedCenter/payableDialog.vue"
export default component.exports